export default function BodySwitchLogo() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="107" height="78" viewBox="0 0 107 78" fill="none">
        <path
          d="M59.6005 45.8358C63.7327 49.037 66.3938 54.0492 66.3938 59.6789C66.3938 69.3189 58.582 77.162 48.981 77.162H18.9365V66.6696H48.981C52.8212 66.6696 55.9434 63.5349 55.9434 59.6789C55.9434 55.8232 52.8212 52.6885 48.981 52.6885H48.3908C52.5128 51.3928 56.2953 49.1214 59.4496 45.9891C59.5007 45.9385 59.5501 45.8868 59.6005 45.8358Z"
          fill="#4AB3BC"
        />
        <path
          d="M40.1682 0C54.6289 0 66.3985 11.8169 66.3985 26.3358C66.3985 33.6672 63.4073 40.3036 58.5738 45.0907C53.8451 49.7862 47.3396 52.6847 40.1682 52.6847H33.6894C23.9966 52.6847 16.1066 44.7628 16.1066 35.0313C16.1066 34.0081 16.1979 32.9983 16.368 32.0148C17.635 39.8579 23.5653 42.1923 33.6894 42.1923H40.1682C48.8681 42.1923 55.9481 35.0837 55.9481 26.3358C55.9481 17.6009 48.8681 10.4924 40.1682 10.4924H10.4504V77.1582H0V0H40.1682Z"
          fill="#4AB3BC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M90.3112 16.7493C99.5089 16.7493 106.992 24.2621 106.992 33.4968C106.992 42.7315 99.5089 50.2446 90.3112 50.2446C81.1135 50.2446 73.6309 42.7315 73.6309 33.4968C73.631 24.2621 81.1135 16.7494 90.3112 16.7493ZM90.3112 26.7978C86.6321 26.7979 83.6391 29.8032 83.6391 33.4968C83.6391 37.1911 86.632 40.1958 90.3112 40.1959C93.9903 40.1959 96.9834 37.1911 96.9834 33.4968C96.9834 29.8032 93.9903 26.7978 90.3112 26.7978Z"
          fill="#4AB3BC"
        />
        <path
          d="M47.8848 27.8728H33.7763C29.8577 27.8728 26.5577 31.0912 26.5531 35.0256C26.5507 37.3283 27.637 39.3821 29.3231 40.6939C24.9675 40.1599 21.9598 38.7255 19.9587 36.2336C16.5593 32.0008 17 25.8839 20.7992 22.0086C23.2225 19.5368 27.1962 17.3807 33.6855 17.3807H47.8848V27.8728Z"
          fill="#4AB3BC"
        />
      </svg>
    </>
  );
}
